import React from 'react';
import Tippy from '@tippyjs/react/headless';
import Box from "../../layout/Box/Box";
import findChildren from "../../../util/findChildren";
import PopoverCore from './PopoverCore';
import DNABox from "../../layout/DNABox/DNABox";
// Lazily Mounted Tippy
// https://gist.github.com/atomiks/520f4b0c7b537202a23a3059d4eec908#gistcomment-3302321
export const LazyTippy = (props) => {
    const [mounted, setMounted] = React.useState(false);
    const lazyPlugin = {
        fn: () => ({
            onShow: () => setMounted(true),
            onHidden: () => setMounted(false),
        }),
    };
    const computedProps = { ...props };
    computedProps.plugins = [lazyPlugin, ...(props.plugins || [])];
    if (props.render) {
        const render = props.render; // let TypeScript safely derive that render is not undefined
        computedProps.render = (...args) => (mounted ? render(...args) : '');
    }
    else {
        computedProps.content = mounted ? props.content : '';
    }
    return <Tippy {...computedProps}/>;
};
const Popover = (props) => {
    const { children, visible, placement, interactive, onBackdropPress, lazyMount = false, disablePopover, fill, type = 'tooltip', } = props;
    const TippyType = lazyMount ? LazyTippy : Tippy;
    const [anchorChildren, , afterChildren] = findChildren(Popover.Anchor, children);
    const [contentChildren] = findChildren(Popover.Content, afterChildren);
    const contentProps = contentChildren?.[0]?.props ?? {};
    const ContentWrapper = (attrs) => (<Box {...attrs} style={[PopoverCore.Content.calculateStyle({ ...props, type, lazyMount }, contentProps), { zIndex: 100 }]}>
      {contentChildren}
    </Box>);
    return disablePopover ? <>{anchorChildren}</> : (<TippyType onClickOutside={onBackdropPress ?? (() => { })} interactive={interactive} visible={visible} placement={placement || 'bottom'} offset={[0, contentProps.offset ?? PopoverCore.DEFAULT_OFFSET]} render={ContentWrapper} appendTo={document.body} // we have to add this because of this issue with interactive popovers: https://atomiks.github.io/tippyjs/v6/faq/#my-tooltip-appears-cut-off-or-is-not-showing-at-all
    >
    <DNABox fill={fill}>
      {anchorChildren}
    </DNABox>
  </TippyType>);
};
Popover.displayName = 'Popover';
Popover.Anchor = PopoverCore.Anchor;
Popover.Content = PopoverCore.Content;
export default Popover;
//# sourceMappingURL=Popover.web.js.map